import { SearchResult } from '@rygen/rygen-ui/model';

import { ShipOrder } from './ShipOrder';

export class ShipOrderSearchResult extends SearchResult<ShipOrder> {
  constructor(opts?: Partial<ShipOrderSearchResult>) {
    super(opts);

    if (opts?.content != null) {
      this.content = opts.content.map((val) => new ShipOrder(val));
    }
  }
}
